import {inject, Injectable} from '@angular/core';
import {AttachProductCard, CreateProductCard, NewProductCard} from "../types/product-card.types";
import {RecordData} from "../../../../types/records-table.types";
import {FormGroup} from "@angular/forms";
import {ProductCardMarketplaceStateService} from "./product-card-marketplace-state.service";

@Injectable({
  providedIn: 'root'
})
export class NewProductCardService {
  private productCardMarketplaceStateService: ProductCardMarketplaceStateService = inject(ProductCardMarketplaceStateService);

  public setNewProductCard(recordData: RecordData): NewProductCard {
    return {
      article: (recordData['vendorCode'] || recordData['offerId']) as string,
      title: (recordData['title'] || recordData['name']) as string,
      articleId: Number(recordData['nmId'] || recordData['id'])
    };
  }

  public setAttachProductCard(id: number, articleId: number): AttachProductCard {
    return {
      marketplace: this.productCardMarketplaceStateService.productCardMarketplaceState(),
      queryParams: {
        id: id,
        articleId: articleId
      }
    };
  }

  public setCreateProductCard(productCardFormGroup: FormGroup): CreateProductCard {
    return {
      marketplace: this.productCardMarketplaceStateService.productCardMarketplaceState(),
      articleId: productCardFormGroup.get('articleId' as string)?.value,
      article: productCardFormGroup.get('article' as string)?.value,
      title: productCardFormGroup.get('title' as string)?.value
    };
  }
}
